<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card treeBox" style="height: calc(100vh - 152px);width: 200px;overflow-y: auto">
            <el-tree :data="treeData" @node-click="clickOrg" default-expand-all :expand-on-click-node="false"></el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <div class="newBox" style="width: calc(100% - 220px)">
            <div class="searchBox">
                <div class="searchGroup">
                    <label>机构名称：</label>
                    <el-input v-model="search_Obj.f_orgname" clearable @keyup.enter.native="doSearch"></el-input>
                </div>
                <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
            </div>
            <el-card ref="right_content" class="box-card">
                <div class="mainBody">
                    <div class="btnBox">
                        <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                    </div>
                    <div class="dataBox">
                        <div class="djBox" v-if="parents && parents.length>0" >
                            <el-breadcrumb separator-class="el-icon-arrow-right">
                                <el-breadcrumb-item><span class="pppp" @click="toChild1(0)">最上级</span></el-breadcrumb-item>
                                <el-breadcrumb-item v-for="p in parents.slice().reverse()" :key="'p'+p.id"><span class="pppp" @click="toChild1(p.id)">{{p.orgname}}</span></el-breadcrumb-item>
                            </el-breadcrumb>
                        </div>
                        <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                            <el-table-column type="selection" align="center" width="50"></el-table-column>
                            <el-table-column prop="orgname" label="机构名称" sortable="custom">
                                <template slot-scope="scope">
                                    <el-button type="text" size="medium" @click="toChild(scope.$index, scope.row)" class="font1">{{scope.row.orgname}}</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="code" label="编码" sortable="custom"></el-table-column>
                            <el-table-column prop="pxorder" label="顺序" sortable="custom"></el-table-column>
                            <el-table-column label="操作" width="240" align="center">
                                <template slot-scope="scope">
                                    <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pageBox">
                        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :pid="pid"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
    </div>
</template>
<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit";
import listutil from "@/libs/listutil";
import { getListData } from '@/api/common'

export default {
    name: "orgList",
    mixins: [listutil],
    components: {Edit, Btns, LabBtns},
    data(){
        return {
            m_name: '机构',
            menu_id: 1400,
            pid: 0,
            orgData: [],
            list_url: "/api/admin/org/list",
            search_Obj: {
                f_orgname: '',
                f_pid: '0',
            },
            del_Obj:{
                url:'/api/admin/org/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            sortData: {
                prop: 'pxorder',
                order: 'ascending'
            },
            pid: 0,
            parents: [],
            treeData: [],
        }
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.parents = res.data.parents;
                    this.treeData = res.data.treeData;
                }
            })
        },
        toChild(index, row){
            this.search_Obj.f_pid = row.id
            this.pid = row.id
            this.current = 1
            this.search_Obj["pageNum"] = this.current;
            this.getData()
        },
        toChild1(pid){
            this.search_Obj.f_pid = pid
            this.pid = pid
            this.current = 1
            this.search_Obj["pageNum"] = this.current;
            this.getData()
        },
        clickOrg(data){
            this.toChild1(data.id)
        }
    }
}
</script>